import React from 'react';
import './SectionHeader.css';
import { useTranslation } from 'react-i18next';

const SectionHeader = ({ title, subtitle, subtitle2, paragraph, titleSize }) => {
  const { t } = useTranslation();
  const isMobile = window.innerWidth <= 768;

  if (!titleSize) {
    if (isMobile) titleSize = "1.8rem";
    else { titleSize = "3rem" }
  } else {
    if (isMobile) titleSize = "1.8rem";
  }

  return (
    <div className="section-header">
      <h1 className="title" style={{ color: '#28588F', fontSize: titleSize }}>{t(title)}</h1>
      <p className="subtitle">{t(subtitle)}</p>
      {subtitle2 && <p className="subtitle2">{t(subtitle2)}</p>}
      <p className="paragraph">{t(paragraph)}</p>
    </div>
  );
};

export default SectionHeader;
